import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import config from "../../../config/config";
import { getToken } from "../../../utils/localStorageMethods";

const apiUrl = config.Url;

// Create a baseQuery with auth headers
const baseQuery = fetchBaseQuery({
  baseUrl: `${apiUrl}/school-vendor`,
  credentials: "include",
  prepareHeaders: (headers) => {
    const token = getToken(); // Get token from cookies or storage
    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
      headers.set("ngrok-skip-browser-warning", "true");
    }
    return headers;
  },
});

export const VendorSlice = createApi({
  reducerPath: "VendorSlice",
  baseQuery: baseQuery,
  tagTypes: ["Vendor"],
  endpoints: (builder) => ({
    // GET all Vendors with filters
    getAllVendors: builder.query({
      query: ({ page, limit, search }) => {
        const params = new URLSearchParams();

        if (page) params.append("page", page);
        if (limit) params.append("limit", limit);
        if (search) params.append("search", search);

        return `/get-vendors?${params.toString()}`;
      },
      providesTags: ["Vendor"],
    }),

    // GET all Vendors with filters
    getAllDrivers: builder.query({
      query: ({ page, limit, search }) => {
        const params = new URLSearchParams();

        if (page) params.append("page", page);
        if (limit) params.append("limit", limit);
        if (search) params.append("search", search);

        return `/get-drivers?${params.toString()}`;
      },
      providesTags: ["Vendor"],
    }),

    getVendorDetails: builder.query({
      query: ({ page = 1, limit = 10, id }) => {
        const params = new URLSearchParams();

        params.append("page", page);
        params.append("limit", limit);
        if (id) params.append("user_id", id);

        return `get-vehicles?${params.toString()}`;
      },
      providesTags: ["Vendor"],
    }),

    // GET all active drivers (no pagination — for assignment dropdowns)
    getAllActiveDrivers: builder.query({
      query: () => `/get-drivers`,
      providesTags: ["Vendor"],
    }),

    getBusFee: builder.mutation({
      query: (data) => ({
        url: "get-bus-fee",
        method: "POST",
        body: data,
      }),
      // invalidatesTags: ["Vendor"],
    }),
  }),
});

// Export hooks for usage in components
export const {
  useGetAllVendorsQuery, // old use
  useGetAllDriversQuery, // new
  useGetAllActiveDriversQuery,
  useGetVendorDetailsQuery,
  useGetBusFeeMutation,
} = VendorSlice;
